import {SET_PATIENTACCOUNT_SELECTION_DATA} from '../actions';
import {
  SelectedPatientAccountingCheckBoxModel,
  SelectedPatientAccountingCheckBoxModelActions
} from '../mappers/SelectedPatientAccountCheckBoxTypesMapper';
import produce, {Draft} from 'immer';
export const initialSelectedCheckBoxState: SelectedPatientAccountingCheckBoxModel =
  {
    selectionData: []
  };

export const selectedPatientAccountingCheckBoxReducer = produce(
  (
    state: Draft<SelectedPatientAccountingCheckBoxModel>,
    action: SelectedPatientAccountingCheckBoxModelActions
  ) => {
    if (action.type === SET_PATIENTACCOUNT_SELECTION_DATA) {
      const listData: any = action.payload?.data;
      state.selectionData = listData;
    }
  },
  initialSelectedCheckBoxState
);
